import { Router } from 'vue-router'

/**
 * Fetch required configs in route navigation.
 * @param router
 */
export function createConfigGuard(router: Router) {
  router.beforeEach(async (to) => {
    const config = to?.meta.config
    if (config) {
      const { fetchConfig } = useConfigStoreWithout()
      // Don't wait to load for configs. It can be loaded in background.
      await fetchConfig(config as string[])
    }
    return true
  })
}
